let ctx: AudioContext | null = null;
let lastPlayed = 0;

/** Short, soft two-tone chime for new support replies. Fails silently when audio is blocked. */
export function playNotifyChime() {
  // Several badges watch the same tickets: play at most one chime per second.
  if (Date.now() - lastPlayed < 1000) return;
  lastPlayed = Date.now();
  try {

    const AC: typeof AudioContext | undefined =
      (window as any).AudioContext || (window as any).webkitAudioContext;
    if (!AC) return;
    if (!ctx) ctx = new AC();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const now = ctx.currentTime;
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.08, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.45);
    gain.connect(ctx.destination);

    [880, 1320].forEach((freq, i) => {
      const osc = ctx!.createOscillator();
      osc.type = "sine";
      osc.frequency.setValueAtTime(freq, now + i * 0.16);
      osc.connect(gain);
      osc.start(now + i * 0.16);
      osc.stop(now + i * 0.16 + 0.2);
    });
  } catch {
    /* audio unavailable */
  }
}
